<template>
  <div class="language-tabs">
    <v-tabs
      active-class="active-language"
      background-color="transparent"
      hide-slider
      :value="tabIndex"
      @change="onchange"
    >
      <v-tab v-for="language in languages" :key="language.language">
        <span class="text">{{ $t(`languages.${language.language.toLowerCase()}`) }}</span>
        <span class="badge">{{ language.keywordCount }}</span>
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
import { VTab, VTabs } from 'vuetify/lib';

export default {
  name: 'LanguageTab',
  components: {
    VTab,
    VTabs,
  },
  props: {
    tabIndex: {
      type: Number,
      default: () => 0,
    },
    languages: {
      type: Array,
      required: true,
    },
    onchange: {
      type: Function,
    },
  },
};
</script>

<style lang="scss">
.language-tabs {
  .v-tabs-bar {
    background: transparent !important;
  }

  .v-tab {
    font-size: $font-size-bigger;
    letter-spacing: 0;
    text-transform: none;
    padding: 1rem 2rem;

    &:before {
      transition: none;
    }

    .badge {
      background-color: $color-normal-pale;
      border-radius: $border-radius-round;
      color: $color-white;
      font-size: $font-size-xxsmall;
      font-weight: bold;
      margin-left: 8px;
      padding: 3px 4px;
      height: $badge-notification-size;
      width: $badge-notification-size;
      line-height: 15px;
      display: flex;
      justify-content: center;
    }

    &:not(.v-tab--active) {
      color: $color-normal-pale !important;
      transition: color 200ms ease-in-out;

      &:hover {
        color: $color-accent !important;
        background-color: transparent !important;

        .badge {
          transition: color 200ms ease-in-out, background-color 200ms ease-in-out;
          background-color: $color-accent-2 !important;
          color: $color-white !important;
        }

        &::before {
          background-color: transparent !important;
        }
      }
    }

    &.active-platform,
    &--active {
      background: $color-white;
      border-radius: $border-radius-small $border-radius-small 0 0;
      color: $color-accent;
      font-weight: bold;

      &:hover {
        background-color: $color-white !important;
        transition: none !important;

        &:before,
        &::before {
          background-color: transparent !important;
          transition: none !important;
        }
      }

      .badge {
        background-color: $color-accent-2;
        color: $color-white;
      }
    }
  }

  // Phones: no folder tab joining a card (the categories are cards of their own there): the
  // languages share the bar, the one shown underlined, as the other phone tabs.
  @include screen-below('tablet') {
    .v-tab {
      flex: 1 1 0;
      min-width: 0;
      padding: 0 12px;
      font-size: 15px;
      border-bottom: 2px solid transparent;

      &.v-tab--active {
        background: transparent;
        border-radius: 0;
        border-bottom-color: $color-accent;

        &:hover {
          background-color: transparent !important;
        }
      }
    }
  }
}
</style>
